import {api} from 'api/setup';
import {
  ICanceledOrderRequest,
  ICreateCardResponse,
  IGetOrdersRequest,
  IOrder,
  IPreOrderRequest,
  IPreOrderResponse,
  ISendReviewRequest,
  ISendReviewResponse,
  ISetOrderResponse,
  MaibCardsType,
  SendNewOrderParams,
} from 'types';

import {CourierExpressSendNewOrderParams} from './courierExpress';

const BASE_PATH = 'orders';

export const getOrderById = (orderId: string): Promise<IOrder> => {
  return api.get(`/${BASE_PATH}/${orderId}`);
};

export const getOrders = (params: IGetOrdersRequest): Promise<IOrder[]> => {
  return api.get(`/${BASE_PATH}`, {
    params,
  });
};

export const ordersCreateCart = (
  params: SendNewOrderParams | CourierExpressSendNewOrderParams | FormData,
): Promise<ICreateCardResponse> => {
  return api.post(`/${BASE_PATH}/create-card`, params);
};

export const createOrder = (
  createOrderPayload: SendNewOrderParams | CourierExpressSendNewOrderParams | FormData,
): Promise<ISetOrderResponse> => {
  return api.post(`/${BASE_PATH}`, createOrderPayload);
};

export const sendReview = (
  orderId: string,
  sendReviewPayload: ISendReviewRequest | FormData,
): Promise<ISendReviewResponse> => {
  return api.post(`/${BASE_PATH}/${orderId}/rate-order`, sendReviewPayload);
};

export const getPreOrder = ({slug}: IPreOrderRequest): Promise<IPreOrderResponse[]> => {
  return api.get(`/preorder/days?slug=${slug}`);
};

export const cancelOrder = ({uuid, reason}: ICanceledOrderRequest): Promise<IOrder> => {
  return api.post(`/${BASE_PATH}/${uuid}/cancel`, {params: reason});
};

export const retryTransaction = (uuid: string): Promise<IOrder> => {
  return api.post(`/${BASE_PATH}/${uuid}/retry_transaction`);
};

export const remindFinishOrder = (): Promise<void> => {
  return api.post('/cart/remind_complete_order');
};
/**
 * CARDS
 * API with create cards, get cards
 */

export const getCustomerCards = (): Promise<MaibCardsType> => {
  return api.get('/maib/my-cards');
};

export const createNewCard = (): Promise<{url: string}> => {
  return api.post(`/maib/add-card`);
};

export const removeCustomerCard = (id: number): Promise<any> => {
  if (!id) return Promise.reject('id cannot be null');
  return api.post(`/maib/${id}/delete-card`);
};

export const setMainCard = (id: number) => {
  return api.post(`/maib/${id}/set-main`);
};
